// extracted by mini-css-extract-plugin
export default {"wrapper":"promo_wrapper__t30bp","wrapperInput":"promo_wrapperInput__EOZRd","input":"promo_input__6eA72","textSummary":"promo_textSummary__seAA1"};